import React from 'react';
import Script from 'next/script';
import { Business } from '../../types/business';
import { generateGoogleBusinessesScript } from '../../helpers/google-local-businesses';

const GoogleLocalBusinessScript = ({
  businesses,
}: {
  businesses: Array<Business>;
}) => {
  if (!businesses || businesses.length === 0) {
    return null;
  }
  const generated = generateGoogleBusinessesScript(businesses);
  if (!generated) {
    return null;
  }
  return (
    <Script type="application/ld+json" key="google-local-businesses">
      {JSON.stringify(generated).replace(/(&quot;)/g, '"')}
    </Script>
  );
};

export default GoogleLocalBusinessScript;
